import { useEffect, useState } from 'react';

/** Значення з затримкою (пошук «під час набору»: запит іде, коли користувач зробив паузу `ms`). */
export function useDebounced<T>(value: T, ms = 250): T {
  const [current, setCurrent] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setCurrent(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return current;
}
